import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import DataroomMembersAdmin from '../components/DataroomMembersAdmin';

const Members = () => {
  const { dataroomUuid } = useParams();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header with Back Button */}
      <div className="bg-white shadow-sm border-b">
        <div className="px-6 py-4">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/my-datarooms')}
              className="mr-4 p-2 hover:bg-gray-100 rounded-lg transition-colors"
            >
              <ArrowLeft className="w-5 h-5 text-gray-600" />
            </button>
            <div>
              <h1 className="text-xl font-semibold text-gray-900">Dataroom Members Management</h1>
              <p className="text-sm text-gray-600 mt-1">Manage members and their access permissions</p>
            </div>
          </div>
        </div>
      </div>

      {/* Main Content */}
      <div className="p-6">
        <DataroomMembersAdmin dataroomUuid={dataroomUuid} />
      </div>
    </div>
  );
};

export default Members;